/*
 * Public API Surface of angular-device-information
 */

export * from './lib/angular-device-information.service';
export * from './lib/angular-device-information.component';
export * from './lib/angular-device-information.module';
